module.exports = __webpack_public_path__ + "./fonts/JosefinSans_400Regular.ttf";